import React from "react";
import "./Departments.css";

const ArogyaVibhag = () => {
  return (
    <div className="dept-page">

      {/* TOP STRIP */}
      <div className="dept-top-strip">
        <span>🏛 महाराष्ट्र शासन</span>
        <span>आरोग्य विभाग</span>
      </div>

      {/* HEADER */}
      <header className="dept-header">

        <div className="dept-header-emblem">
          🏥
        </div>

        <div className="dept-header-text">

          <div className="dept-header-org">
            जिल्हा परिषद विभाग
          </div>

          <h1 className="dept-header-title">
            आरोग्य विभाग
          </h1>

          <div className="dept-header-subtitle">
            प्राथमिक आरोग्य सेवा व सार्वजनिक आरोग्य व्यवस्थापन
          </div>

        </div>

        <div className="dept-header-badge">
          HEALTH DEPARTMENT
        </div>

      </header>

      {/* NAVIGATION */}
      <div className="dept-nav">

        <button className="dept-nav-tab active">
          विभाग माहिती
        </button>

        <button className="dept-nav-tab">
          माता व बाल आरोग्य
        </button>

        <button className="dept-nav-tab">
          प्राथमिक आरोग्य सेवा
        </button>

        <button className="dept-nav-tab">
          संपर्क
        </button>

      </div>

      {/* MAIN */}
      <main className="dept-main">

        {/* HERO */}
        <section className="dept-intro">

          <div className="dept-intro-label">
            सर्वांसाठी आरोग्य
          </div>

          <p className="dept-intro-text">
            <strong>आरोग्य विभाग</strong> हा ग्रामीण व शहरी
            भागामध्ये प्राथमिक आरोग्य सेवा, माता व बाल आरोग्य,
            लसीकरण, रोग प्रतिबंधक सेवा, कुटुंब नियोजन,
            उपचारात्मक सेवा आणि सार्वजनिक आरोग्य व्यवस्थापन
            यासाठी कार्यरत आहे. प्राथमिक आरोग्य सेवा ही
            “सर्वांना आरोग्य” या उद्दिष्टाची गुरुकिल्ली
            मानून विविध आरोग्य सेवा कार्यक्रमांची
            प्रभावी अंमलबजावणी करण्यात येते.
          </p>

        </section>

        {/* STATS */}
        <section className="dept-stats">

          <div className="dept-stat-card">
            <div className="dept-stat-value">24x7</div>
            <div className="dept-stat-label">
              तातडीची आरोग्य सेवा
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">6</div>
            <div className="dept-stat-label">
              आंतररुग्ण बेड सुविधा
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">5</div>
            <div className="dept-stat-label">
              गर्भवती तपासण्या
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">100%</div>
            <div className="dept-stat-label">
              लसीकरण अभियान
            </div>
          </div>

        </section>

        {/* LEFT CONTENT */}
        <div>

          {/* MATERNAL HEALTH */}
          <section className="dept-section">

            <div className="dept-section-header">

              <div className="dept-section-icon">
                👩‍⚕️
              </div>

              <h2 className="dept-section-title">
                माता व बाल आरोग्य सेवा
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  प्रसुतीपूर्व काळजी
                </div>

                <div className="scheme-card-desc">
                  गरोदर महिलांची नोंदणी, नियमित तपासणी,
                  रक्तदाब, हिमोग्लोबीन, लोह व फोलिक
                  अ‍ॅसिड गोळ्यांचे वितरण.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  प्रसुतीदरम्यान सेवा
                </div>

                <div className="scheme-card-desc">
                  सुरक्षित संस्थात्मक प्रसुती,
                  प्रशिक्षित आरोग्य सेवकांमार्फत
                  प्रसुती सेवा व संदर्भ सेवा.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  प्रसुतीपश्चात सेवा
                </div>

                <div className="scheme-card-desc">
                  गृहभेटी, स्तनपान मार्गदर्शन,
                  नवजात बालकांची काळजी व समुपदेशन.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  बालकांचे आरोग्य
                </div>

                <div className="scheme-card-desc">
                  लसीकरण, पोषण, जीवनसत्व अ,
                  कुपोषण प्रतिबंधन व उपचार.
                </div>

              </div>

            </div>

          </section>

          {/* HEALTH SERVICES */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                💉
              </div>

              <h2 className="dept-section-title">
                आरोग्य संस्थांद्वारे सेवा
              </h2>

            </div>

            <div className="dept-services-grid">

              <div className="dept-service-item">
                लसीकरण सेवा
              </div>

              <div className="dept-service-item">
                नवजात शिशु काळजी
              </div>

              <div className="dept-service-item">
                कुटुंब नियोजन
              </div>

              <div className="dept-service-item">
                पौगंडावस्था आरोग्य
              </div>

              <div className="dept-service-item">
                उपचारात्मक सेवा
              </div>

              <div className="dept-service-item">
                आरोग्य शिक्षण
              </div>

              <div className="dept-service-item">
                संदर्भ सेवा
              </div>

              <div className="dept-service-item">
                पोषण सेवा
              </div>

            </div>

          </section>

          {/* PRIMARY HEALTH */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🏨
              </div>

              <h2 className="dept-section-title">
                प्राथमिक आरोग्य केंद्र सेवा
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  बाह्यरुग्ण सेवा
                </div>

                <div className="scheme-card-desc">
                  सकाळी ४ तास व संध्याकाळी २ तास
                  नियमित आरोग्य सेवा उपलब्ध.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  २४ तास तातडीची सेवा
                </div>

                <div className="scheme-card-desc">
                  अपघात, श्वानदंश, सर्पदंश,
                  जखमा व आपत्कालीन उपचार.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  आंतररुग्ण सेवा
                </div>

                <div className="scheme-card-desc">
                  ६ बेड सुविधा व आवश्यक
                  उपचारात्मक सेवा उपलब्ध.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  संदर्भ सेवा
                </div>

                <div className="scheme-card-desc">
                  विशेषज्ञ उपचारासाठी रुग्णांना
                  तत्पर संदर्भ सेवा उपलब्ध.
                </div>

              </div>

            </div>

          </section>

          {/* FAMILY PLANNING */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                👨‍👩‍👧
              </div>

              <h2 className="dept-section-title">
                कुटुंब नियोजन व जनजागृती
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  गर्भनिरोधक सेवा
                </div>

                <div className="scheme-card-desc">
                  निरोध, तांबी, गर्भनिरोधक गोळ्या
                  व तात्काळ गर्भनिरोधक सुविधा.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  कायमस्वरूपी पद्धती
                </div>

                <div className="scheme-card-desc">
                  स्त्री नसबंदी व पुरुष नसबंदी
                  शस्त्रक्रिया सेवा.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  आरोग्य शिक्षण
                </div>

                <div className="scheme-card-desc">
                  स्वच्छता, पोषण, एड्स,
                  लैंगिक आजार व किशोर आरोग्य
                  विषयक मार्गदर्शन.
                </div>

              </div>

            </div>

          </section>

          {/* INDICATORS */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                📊
              </div>

              <h2 className="dept-section-title">
                आरोग्य सूचकांक
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">
                <div className="scheme-card-name">
                  जन्मदर (CBR)
                </div>

                <div className="scheme-card-desc">
                  पुणे – 11.22 | महाराष्ट्र – 12.61
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  बालमृत्यू दर (IMR)
                </div>

                <div className="scheme-card-desc">
                  Pune – 8.90 | महाराष्ट्र – 8.20
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  नवजात मृत्यू दर (NMR)
                </div>

                <div className="scheme-card-desc">
                  पुणे – 5.44 | महाराष्ट्र – 6.28
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  एकूण मृत्यूदर (CDR)
                </div>

                <div className="scheme-card-desc">
                  पुणे – 7.64 | महाराष्ट्र – 6.48
                </div>
              </div>

            </div>

          </section>

        </div>

        {/* SIDEBAR */}
        <aside className="dept-sidebar">

          {/* INFO */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              विभाग माहिती
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                सेवा प्रकार
              </div>

              <div className="dept-info-val">
                प्राथमिक आरोग्य
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                तातडीची सेवा
              </div>

              <div className="dept-info-val">
                24x7 उपलब्ध
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                आरोग्य केंद्र
              </div>

              <div className="dept-info-val">
                ग्रामीण व शहरी
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                लसीकरण
              </div>

              <div className="dept-info-val">
                नियमित मोहीम
              </div>
            </div>

          </div>

          {/* CONTACT */}
          <div className="dept-contact-card">

            <div className="dept-contact-card-title">
              संपर्क माहिती
            </div>

            <div className="dept-contact-row">
              <span>📞</span>
              <span>020-26129965</span>
            </div>

            <div className="dept-contact-row">
              <span>📍</span>
              <span>जिल्हास्तरीय कार्यालये</span>
            </div>

            <div className="dept-contact-row">
              <span>🏥</span>
              <span>प्राथमिक आरोग्य केंद्र</span>
            </div>

          </div>

          {/* QUICK SERVICES */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              प्रमुख सेवा
            </div>

            <div className="dept-services-grid">

              <div className="dept-service-item">
                माता आरोग्य
              </div>

              <div className="dept-service-item">
                बाल आरोग्य
              </div>

              <div className="dept-service-item">
                लसीकरण
              </div>

              <div className="dept-service-item">
                प्रसुती सेवा
              </div>

              <div className="dept-service-item">
                कुटुंब नियोजन
              </div>

              <div className="dept-service-item">
                तातडीची सेवा
              </div>

            </div>

          </div>

        </aside>

      </main>

      {/* FOOTER */}
      <footer className="dept-footer">
        <strong>आरोग्य विभाग</strong>
        {" "}• जिल्हा परिषद प्रशासन
      </footer>

    </div>
  );
};

export default ArogyaVibhag;